import React, { useState } from 'react';

const CourtMedCheckBox = ({ column, dispatch, rowData }) => {

    const [isChecked, setIsChecked] = useState(false);

    const handleCheckboxChange = () => {
        setIsChecked(!isChecked);
        dispatch({
            type: 'UpdateCellValue',
            rowKeyValue: rowData.rxf_id,
            columnKey: column.key,
            value: !isChecked,
            cellComponentType: 'CourtMed'
        });
    };

    return (
        <div key={rowData.rxf_number}>
            <input
                type="checkbox"
                id={rowData.rxf_number}
                checked={isChecked}
                onChange={handleCheckboxChange}
            />
        </div>
    );
};

export default CourtMedCheckBox;